import React, { FC } from 'react'

import { IconConnectedCarProps } from './IconConnectedCar.types'
import * as Styled from './styles/IconConnectedCar.style'

import { nonThemeableRules } from '../../ruleSet'

const IconConnectedCar: FC<IconConnectedCarProps> = ({
  size = nonThemeableRules.defaultSize as number as IconConnectedCarProps['size'],
  isResponsive = false,
}: IconConnectedCarProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M18.89 32a5 5 0 1 1-10.003-.001A5 5 0 0 1 18.89 32Zm20.062 0a5 5 0 0 1-10 0 5 5 0 1 1 10 0Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M34.75 21.227a.48.48 0 0 0 .292.173c4.023.777 7.875 4.703 7.875 8.963a2.578 2.578 0 0 1-2.575 2.575h-1.48a5 5 0 1 0-9.82 0h-10.25a5 5 0 1 0-9.822-.008 4.328 4.328 0 0 1-4.06-4.317 7.66 7.66 0 0 1 1.597-4.69c.522-.657.992-1.354 1.405-2.083 1.865-3.372 5.128-8.902 12.54-8.902 6.21 0 9.448 2.394 14.298 8.29Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M20.173 24.172a4 4 0 0 1 5.655 0m-8.485-2.83a8 8 0 0 1 11.314 0'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M23.5 27a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z' fill='#EA1A1A' stroke='#EA1A1A' />
        <path
          d='M23 27.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconConnectedCar
